module.exports = __webpack_public_path__ + "static/media/cosplay7.c585d061.jpg";